var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "workflow-list",
      class: { loading: _vm.loading, ready: !_vm.loading }
    },
    [
      _c(
        "header",
        { staticClass: "filters" },
        [
          _vm.filterMode === _vm.FILTER_MODE_ADVANCED
            ? [
                _c(
                  "flex-grid",
                  { attrs: { width: "100%" } },
                  [
                    _c(
                      "flex-grid-item",
                      { attrs: { grow: "1" } },
                      [
                        _c("text-input", {
                          attrs: {
                            label: "Query",
                            type: "search",
                            name: "queryString",
                            value: _vm.queryString
                          },
                          on: { input: _vm.onFilterChange }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "flex-grid-item",
                      [
                        _c("button-fill", {
                          attrs: {
                            disabledLabel: "Advanced visibility is not enabled",
                            enabled: _vm.filterModeButtonEnabled,
                            label: _vm.filterModeButtonLabel,
                            uppercase: ""
                          },
                          on: { click: _vm.onFilterModeClick }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "flex-grid",
                  { attrs: { width: "100%" } },
                  [
                    _c(
                      "flex-grid-item",
                      { attrs: { grow: "1" } },
                      [
                        _c("text-input", {
                          attrs: {
                            label: "Workflow ID",
                            type: "search",
                            name: "workflowId",
                            value: _vm.workflowId
                          },
                          on: { input: _vm.onFilterChange }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "flex-grid-item",
                      { attrs: { grow: "1" } },
                      [
                        _c("text-input", {
                          attrs: {
                            label: "Workflow Name",
                            type: "search",
                            name: "workflowName",
                            value: _vm.workflowName
                          },
                          on: { input: _vm.onFilterChange }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "flex-grid-item",
                      { attrs: { grow: "1", width: "160px" } },
                      [
                        _c("select-input", {
                          attrs: {
                            "data-cy": "status-filter",
                            label: "Status",
                            name: "status",
                            options: _vm.statusList,
                            value: _vm.status
                          },
                          on: { change: _vm.onStatusChange }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isCronInputVisible
                      ? _c(
                          "feature-flag",
                          {
                            attrs: {
                              grow: "1",
                              margin: "5px",
                              name: "workflowListIsCron",
                              width: "115px"
                            }
                          },
                          [
                            _c("select-input", {
                              attrs: {
                                label: "Cron",
                                name: "isCron",
                                options: _vm.isCronList,
                                value: _vm.isCron
                              },
                              on: { change: _vm.onIsCronChange }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "flex-grid-item",
                      { attrs: { grow: "1", width: "105px" } },
                      [
                        _c("text-input", {
                          attrs: {
                            label: "Filter by",
                            "max-width": "100%",
                            name: "filterBy",
                            readonly: "",
                            value: _vm.filterBy
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "flex-grid-item",
                      [
                        _c("date-range-picker", {
                          attrs: {
                            "date-range": _vm.range,
                            "max-days": _vm.maxRetentionDays,
                            "min-start-date": _vm.minStartDate
                          },
                          on: { change: _vm.setRange }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "flex-grid-item",
                      [
                        _c("button-fill", {
                          attrs: {
                            disabledLabel: "Advanced visibility is not enabled",
                            enabled: _vm.filterModeButtonEnabled,
                            label: _vm.filterModeButtonLabel,
                            uppercase: ""
                          },
                          on: { click: _vm.onFilterModeClick }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("error-message", { attrs: { error: _vm.error } }),
      _vm._v(" "),
      !_vm.error
        ? _c("workflow-grid", {
            attrs: {
              workflows: _vm.formattedResults,
              noResultsText: _vm.noResultsMessageText,
              loading: _vm.loading
            },
            on: { onScroll: _vm.onWorkflowGridScroll }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62bf6843", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62bf6843","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/workflow-list/component.vue
// module id = 1679
// module chunks = 0